import React from "react";
import payBybancontact from "iconsTwoColors/cx/pay-by-bancontact.png";

export default function PayByBancontact() {
  return (
    <img src={payBybancontact} alt="Bancontact" width={25} title="Bancontact" />
  );
}
